import { PillarIcon } from "@/components/PillarIcon";

export function ProfileBars({ profile, pillars, pillarOrder, compact = false }) {
  return (
    <div className="space-y-3" data-testid="profile-bars">
      {pillarOrder.map((p) => {
        const meta = pillars[p];
        const value = profile.bars[p];
        const isPriority = profile.priority === p;
        return (
          <div key={p} data-testid={`bar-${p}`} className="flex items-center gap-3">
            <div
              className="flex items-center gap-1.5 shrink-0"
              style={{ width: compact ? 92 : 116 }}
            >
              <PillarIcon pillar={p} className="w-4 h-4" style={{ color: meta.color }} />
              <span
                className="text-sm font-semibold truncate"
                style={{ color: isPriority ? meta.color : "#EAC6D9" }}
              >
                {meta.name}
              </span>
            </div>
            <div className="flex-1 flex gap-1.5">
              {[1, 2, 3, 4, 5].map((seg) => (
                <div
                  key={seg}
                  className="h-2.5 flex-1 rounded-full transition-all duration-500"
                  style={{
                    backgroundColor: seg <= value ? meta.color : "#6B2247",
                    opacity: seg <= value ? (isPriority ? 1 : 0.85) : 1,
                    boxShadow: isPriority && seg <= value ? `0 0 8px ${meta.color}55` : "none",
                  }}
                />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
